/* eslint-disable import/no-unresolved, import/extensions */
const { withEffect } = require('./lib/withEffect');
const { appContextFactory } = require('./lib/appContextFactory');

module.exports = withEffect;
exports = module.exports;
exports.withEffect = withEffect;
exports.appContextFactory = appContextFactory;
